import React, { useState, useEffect } from "react";
import ComplaintComponent from "../../components/Complaint";
import SelectDropdown from "../../components/SelectDropdown";
import { RiAdminFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { GetComplaintByType } from "../../store/actions/user-action";
import { HandleAssignedComplaint } from "../../store/actions/user-action";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../../components/Modal";

function ComplaintPage() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const [state, setState] = useState({
    input: "",
    complaintType: "Open", // Default value for complaint status
    currentPage: 1, // Track current page
  });

  const [refresh, setRefresh] = useState(false); // New state to trigger useEffect
  const pageSize = 10; // Set the number of complaints per page

  const handleChange = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: value,
      currentPage: 1, // Reset to first page when the complaint type changes
    }));
  };

  // Select complaint details from Redux state
  const { complaintDetails } =
    useSelector((state) => state.complaintDetails) || {};

  // useEffect to fetch data based on selected complaintType and page
  useEffect(() => {
    if (state?.complaintType) {
      let payload = {
        pageNumber: state?.currentPage,
        pageSize, // Pass pageSize to the API
        complaintType: state?.complaintType.toLowerCase(),
      };
      // Ensure the request is made on page change
      dispatch(GetComplaintByType(payload));
    }
  }, [state.complaintType, state.currentPage, dispatch, refresh]);

  // Function to return data based on selected complaint type
  const getDataForComplaintType = () => {
    return complaintDetails || []; // Return data from Redux store
  };

  const handleAssigned = (item) => {
    let payload = {
      complaintId: item._id,
    };
    dispatch(HandleAssignedComplaint(payload));
    setRefresh((prev) => !prev);
  };

  // Pass complaint data to ManageComplaintPage
  const manageComplaint = (item) => {
    navigate("/manage-complaint", { state: { complaint: item } });
  };

  const handlePageChange = (page) => {
    setState((prevState) => ({
      ...prevState,
      currentPage: page,
    }));
  };

  // Pagination logic based on the number of complaints returned
  const paginatedData = getDataForComplaintType(); // Data for the current page

  // Check if we need to show "Next" button based on the response length
  const showNextButton = paginatedData.length === pageSize;
  // Check if "Previous" button should be disabled (on the first page)
  const showPreviousButton = state.currentPage > 1;

  return (
    <div>
      <div className="w-1/6 m-4">
        <SelectDropdown
          className="p-2 border border-gray-300 rounded-md bg-white"
          name="complaintType"
          icon={<RiAdminFill />}
          value={state.complaintType}
          onChange={(e) => handleChange("complaintType", e.target.value)}
          options={[
            { value: "Open", label: "Open" },
            { value: "Assigned", label: "Assigned" },
            { value: "Closed", label: "Closed" },
          ]}
        />
      </div>

      <div className="p-[25px] rounded-md border-[solid] border bg-white">
        <ComplaintComponent
          data={paginatedData} // Use the paginated data
          onAssigned={handleAssigned}
          complaintStatus={state?.complaintType}
          manageComplaint={manageComplaint} // Pass the function here
        />

        {/* Pagination controls */}
        <div className="flex justify-between items-center mt-4">
          <button
            className={`px-3 py-1 ${
              !showPreviousButton ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={() => handlePageChange(state.currentPage - 1)}
            disabled={!showPreviousButton}
          >
            Previous
          </button>
          <span>Page {state?.currentPage}</span>
          <button
            className={`px-3 py-1 ${
              !showNextButton ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={() => handlePageChange(state?.currentPage + 1)}
            disabled={!showNextButton}
          >
            Next
          </button>
        </div>

        {/* No complaints */}
        {paginatedData?.length === 0 && (
          <div className="mt-4 text-center">
            <p>No complaints found for the selected type.</p>
          </div>
        )}
      </div>
      {/* <ModalComponent 
            showModal={true} 
            setShowModal={setShowModal} 
            title="Complaint Details"/> */}
    </div>
  );
}

export default ComplaintPage;
